import React from "react";
import styles from "./Tag.module.css"
import IconCross from "../icons/IconCross";

interface TagProps extends React.ComponentPropsWithoutRef<"div"> {
    value: string;
    children: React.ReactNode
    onClickClose?: (tagValue: string) => void;
}

const Tag = ({children, value, onClickClose, ...rest}: TagProps) =>{
    const className = rest.className ?? "";

    const iconOnClick = (_: React.MouseEvent<HTMLDivElement>) => {
        if (onClickClose)
            onClickClose(value);
    }

    return (
        <div className={`${styles.container} ${className}`}>
            <div className={styles.childrenContainer}>
                {children}
            </div>
            <div className={styles.iconContainer} onClick={iconOnClick}>
                <IconCross className={styles.icon}/>
            </div>
        </div>
    );
}

export default Tag;